import React, { useState } from 'react';
import { formatCurrency } from '../utils/currencyFormatter';
import { TruckIcon, ClipboardListIcon, XIcon } from 'lucide-react';
import { getDefaultCurrency } from '../../utils/appSettings';
export function PurchaseOrderList({
  purchaseOrders,
  locale = 'en-US',
  onCreateReceipt
}) {
  const defaultCurrency = getDefaultCurrency();
  const [showReceiptsModal, setShowReceiptsModal] = useState(false);
  const [selectedPO, setSelectedPO] = useState(null);
  // Sample receipt data - in a real app this would come from your backend
  const sampleReceipts = {
    'PO-2023-001': [{
      id: 'GR-001-001',
      date: '2023-10-15',
      receivedBy: 'John Smith',
      items: [{
        description: 'Server Rack',
        quantity: 1,
        remainingQuantity: 1
      }, {
        description: 'Server Unit',
        quantity: 2,
        remainingQuantity: 1
      }],
      status: 'Partial'
    }],
    'PO-2023-002': [{
      id: 'GR-002-001',
      date: '2023-10-08',
      receivedBy: 'Jane Doe',
      items: [{
        description: 'Brochures',
        quantity: 500,
        remainingQuantity: 500
      }],
      status: 'Partial'
    }, {
      id: 'GR-002-002',
      date: '2023-10-12',
      receivedBy: 'Mike Johnson',
      items: [{
        description: 'Brochures',
        quantity: 500,
        remainingQuantity: 0
      }, {
        description: 'Banners',
        quantity: 5,
        remainingQuantity: 0
      }],
      status: 'Complete'
    }]
  };
  const handleViewReceipts = po => {
    setSelectedPO(po);
    setShowReceiptsModal(true);
  };
  const closeReceiptsModal = () => {
    setShowReceiptsModal(false);
    setSelectedPO(null);
  };
  const getReceiptsForPO = poId => {
    return sampleReceipts[poId] || [];
  };
  return <>
      <ul className="divide-y divide-gray-200" data-id="element-14507">
        {purchaseOrders.length === 0 ? <li className="py-4 px-6 text-center text-gray-500" data-id="element-14508">
            No purchase orders found
          </li> : purchaseOrders.map(po => <li key={po.id} className="px-4 py-4 sm:px-6 hover:bg-gray-50" data-id="element-14509">
              <div className="flex items-center justify-between" data-id="element-14510">
                <div data-id="element-14511">
                  <p className="text-sm font-medium text-indigo-600 truncate" data-id="element-14512">
                    {po.id} - {po.name}
                  </p>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-14513">
                    Vendor: {po.vendor}
                  </p>
                </div>
                <div className="ml-6 flex-shrink-0 flex items-center space-x-2" data-id="element-14514">
                  <p className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-14515">
                    {po.status}
                  </p>
                  <button onClick={() => handleViewReceipts(po)} className="inline-flex items-center px-3 py-1 border border-gray-300 text-xs font-medium rounded shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-14516">
                    <ClipboardListIcon className="h-3 w-3 mr-1" data-id="element-14517" />
                    View Receipts
                  </button>
                  {onCreateReceipt && <button onClick={() => onCreateReceipt(po.id)} className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-14518">
                      <TruckIcon className="h-3 w-3 mr-1" data-id="element-14519" />
                      Create Receipt
                    </button>}
                </div>
              </div>
              <div className="mt-2 sm:flex sm:justify-between" data-id="element-14520">
                <div className="sm:flex" data-id="element-14521">
                  <p className="flex items-center text-sm text-gray-500" data-id="element-14522">
                    <svg className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-14523">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" data-id="element-14524" />
                    </svg>
                    Created on {po.date}
                  </p>
                </div>
                <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-14525">
                  <svg className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-14526">
                    <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" data-id="element-14527" />
                  </svg>
                  {formatCurrency(po.total, po.currency || defaultCurrency, locale)}
                </div>
              </div>
              {po.requisitionId && <div className="mt-2 text-xs text-gray-500" data-id="element-14528">
                  Created from requisition: {po.requisitionId}
                </div>}
              {/* Receipt status indicator */}
              {sampleReceipts[po.id] && <div className="mt-2" data-id="element-14529">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-14530">
                    <TruckIcon className="h-3 w-3 mr-1" data-id="element-14531" />
                    {sampleReceipts[po.id].length} receipt(s)
                  </span>
                </div>}
            </li>)}
      </ul>

      {/* Receipts Modal */}
      {showReceiptsModal && selectedPO && <div className="fixed z-10 inset-0 overflow-y-auto" data-id="element-14532">
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-14533">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true" data-id="element-14534">
              <div className="absolute inset-0 bg-gray-500 opacity-75" data-id="element-14535"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true" data-id="element-14536">
              &#8203;
            </span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full" data-id="element-14537">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-14538">
                <div className="flex justify-between items-center pb-3 border-b border-gray-200" data-id="element-14539">
                  <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-14540">
                    Receipts for {selectedPO.id} - {selectedPO.name}
                  </h3>
                  <button onClick={closeReceiptsModal} className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-14541">
                    <XIcon className="h-6 w-6" data-id="element-14542" />
                  </button>
                </div>
                <div className="mt-4" data-id="element-14543">
                  {getReceiptsForPO(selectedPO.id).length > 0 ? <div className="space-y-4" data-id="element-14544">
                      {getReceiptsForPO(selectedPO.id).map(receipt => <div key={receipt.id} className="border border-gray-200 rounded-md p-4" data-id="element-14545">
                          <div className="flex justify-between items-center mb-2" data-id="element-14546">
                            <div data-id="element-14547">
                              <h4 className="text-sm font-medium text-gray-900" data-id="element-14548">
                                {receipt.id}
                              </h4>
                              <p className="text-xs text-gray-500" data-id="element-14549">
                                Received on {receipt.date} by{' '}
                                {receipt.receivedBy}
                              </p>
                            </div>
                            <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${receipt.status === 'Complete' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-14550">
                              {receipt.status}
                            </span>
                          </div>
                          <table className="min-w-full divide-y divide-gray-200 mt-2" data-id="element-14551">
                            <thead className="bg-gray-50" data-id="element-14552">
                              <tr data-id="element-14553">
                                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14554">
                                  Item
                                </th>
                                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14555">
                                  Quantity
                                </th>
                                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14556">
                                  Remaining
                                </th>
                              </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200" data-id="element-14557">
                              {receipt.items.map((item, idx) => <tr key={idx} data-id="element-14558">
                                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900" data-id="element-14559">
                                    {item.description}
                                  </td>
                                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-14560">
                                    {item.quantity}
                                  </td>
                                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-14561">
                                    {item.remainingQuantity}
                                  </td>
                                </tr>)}
                            </tbody>
                          </table>
                        </div>)}
                    </div> : <p className="text-center text-gray-500 py-4" data-id="element-14562">
                      No receipts found for this purchase order.
                    </p>}
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" data-id="element-14563">
                <button type="button" onClick={() => onCreateReceipt(selectedPO.id)} className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm" data-id="element-14564">
                  <TruckIcon className="h-4 w-4 mr-1" data-id="element-14565" />
                  Create New Receipt
                </button>
                <button type="button" onClick={closeReceiptsModal} className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" data-id="element-14566">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>}
    </>;
}